module.exports = __webpack_public_path__ + "img/Conflict Confronter.d9605de4.svg";